export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20221125_0333_MR1_5104.0b029718.jpg";